// import { HomeActionType } from "service/actionType"

const initialState = {
  userDetail: {},
  selectedDoctorType: "GP",
  hide:false
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case "USER_MOBILE_NUMBER":
      console.log(payload, "payyyy");
      return {
        ...state,
        userDetail: { ...state.userDetail, ...payload },
      };
    case "DOCTER_TYPE":
      return {
        ...state,
        selectedDoctorType: payload,
      };

    default:
      return state;
  }
};
